import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';

export class BillPaymentListItem extends SearchModelBase {
    postDate: string | null = null;
    fromPostDate: string | null = null;
    toPostDate: string | null = null;
    etfStr: string = '';
    checkNo: string = '';
    vendor: string = '';
    paidTo: string = '';
    invoiceNo: string = '';
    currency: string = '';
    totalAmt: number|null = null;
    fromTotalAmt: number|null = null;
    toTotalAmt: number|null = null;
    bankName: string = '';
    depositDate: string | null = null;
    fromDepositDate: string | null = null;
    toDepositDate: string | null = null;
    isDraft: boolean|null = null;
    void: boolean|null = null;
    voidDate: string | null = null;
    fromVoidDate: string | null = null;
    toVoidDate: string | null = null;
    chkPrint: boolean|null = null;
    block: boolean|null = null;
    remark: string = '';
    u1ID: string = '';
    id: number = 0;
    paidToId: number = 0;
    u1Date: string | null = null;
    fromU1Date: string | null = null;
    toU1Date: string | null = null;
    u2ID: string = '';
    u2Date: string | null = null;
    status: string = '';
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    chkPrtID: string = '';
    chkPrtDate: string | null = null;
    vendorId: number = 0;
    firstVendor: string = '';

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true}),
        XCol.Create({ col: 1, text: 'Draft', width: 40, dataIndex: 'isDraft', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 2, text: 'Block', width: 40, dataIndex: 'block', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 3, text: 'Date', width: 75, dataIndex: 'postDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 4, text: 'Vendor', width: 150, dataIndex: 'vendor', defaultColumnFocus : true}),
        XCol.Create({ col: 5, text: 'Pay To', width: 150, dataIndex: 'paidTo'}),
        XCol.Create({ col: 6, text: 'Type', width: 40, dataIndex: 'etfStr', align: XCol.XAlignType.Center}),
        XCol.Create({ col: 7, text: 'Check #', width: 100, dataIndex: 'checkNo'}),
        XCol.Create({ col: 8, text: 'Bank', width: 120, dataIndex: 'bankName'}),
        XCol.Create({ col: 9, text: 'CUR', width: 40, dataIndex: 'currency'}),
        XCol.Create({ col: 10, text: 'Amount', width: 100, dataIndex: 'totalAmt', type: XCol.XCellType.Double, align: XCol.XAlignType.Right, formatString: '#,##0.00', noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'Clear Date', width: 75, dataIndex: 'depositDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 12, text: 'Void', width: 40, dataIndex: 'void', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        // XCol.Create({ col: 13, text: 'Void Date', width: 75, dataIndex: 'voidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false}),
        XCol.Create({ col: 14, text: 'Print', width: 40, dataIndex: 'chkPrint', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 15, text: 'Billings', width: 100, dataIndex: 'invoiceNo'}),
        XCol.Create({ col: 16, text: 'Remark', width: 150, dataIndex: 'remark'}),
        XCol.Create({ col: 17, text: 'Create Date', width: 100, dataIndex: 'u1Date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 18, text: 'Create by', width: 100, dataIndex: 'u1ID'}),
        XCol.Create({ col: 19, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.Date, align: XCol.XAlignType.Center}),
        XCol.Create({ col: 20, text: 'Update by', width: 100, dataIndex: 'u2ID'}),
        ];


    public static getExportCollection(): XCol.XExportColumn[] {
        return this.ExportCollection;
    };
	
    public static OrderBy = { orderBy: BillPaymentListItem.prototype.postDate, orderByAscending: false };

    public static formatData(data: BillPaymentListItem[]) {
        return data.map((d: BillPaymentListItem) => ({
          ...d,
        }));
    }
    
    public static MapSearchFields:{[key: string]: {[key: string]: string}} = {
        postDate: {from: 'fromPostDate', to: 'toPostDate'},
        depositDate: {from: 'fromDepositDate', to: 'toDepositDate'},
        voidDate: {from: 'fromVoidDate', to: 'toVoidDate'},
        u1Date: {from: 'fromU1Date', to: 'toU1Date'},
        u2Date: {from: 'fromU2Date', to: 'toU2Date'},
        totalAmt: {from: 'fromTotalAmt', to: 'toTotalAmt'},
    }
}
